import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import supabase from '../supabaseClient';
import { Box, Center, Spinner, Text, Button, VStack } from '@chakra-ui/react';

const AuthCallback = () => {
  const [message, setMessage] = useState('Verifying your email...');
  const [verified, setVerified] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.hash.slice(1));
    const access_token = params.get('access_token');
    const refresh_token = params.get('refresh_token');

    if (!access_token || !refresh_token) {
      setMessage('Invalid or missing verification tokens.');
      return;
    }

    const verifyEmail = async () => {
      const { error } = await supabase.auth.setSession({
        access_token,
        refresh_token,
      });

      if (error) {
        setMessage('Verification failed. ' + error.message);
      } else {
        setVerified(true);
        setMessage('Email successfully verified!');
      }
    };

    verifyEmail();
  }, [location]);

  return (
    <Center h="100vh">
      <VStack spacing={6}>
        {!verified && <Spinner size="xl" />}
        <Text fontSize="lg">{message}</Text>
        {verified && (
          <Button colorScheme="teal" onClick={() => navigate('/sign-in')}>
            Click here to sign in
          </Button>
        )}
      </VStack>
    </Center>
  );
};

export default AuthCallback;
